import { ChangeEvent } from "react";
import { CSSProperties } from "styled-components";

import InputTextAreaStyles from "../styles/components/InputTextAreaStyles";

const {
    StyledFormControl,
    StyledLabelFloating,
    StyledFormGroup,
    StyledLengthInfo,
} = InputTextAreaStyles;

interface InputTextAreaProps {
    label?: string;
    value: string;
    placeholder?: string;
    onChange?: (
        event: ChangeEvent<{
            value: unknown;
        }>
    ) => void;
    style?: CSSProperties;
    disabled?: boolean;
    maxLength?: number;
    viewLengthInfo?: boolean;
    clear?: boolean;
}

function InputLabelTextArea({
    label,
    placeholder,
    style,
    disabled = false,
    maxLength,
    viewLengthInfo = true,
    clear = false,
    value,
    onChange,
}: InputTextAreaProps) {
    const labelStyle = {
        backgroundColor: disabled ? "#e9ecef" : "#fff",
    };
    const controlStyle = {
        backgroundColor: disabled ? "#e9ecef" : "#fff",
        paddingTop: label ? "25px" : "12px",
        borderWidth: clear ? "0px 0px 1px 0px" : "1px 1px 1px 1px",
        borderRadius: clear ? "0" : "4px",
    };

    const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
        if (onChange && maxLength) {
            const eventValue = event.target.value as string;
            const shouldSetValue = eventValue.length < maxLength + 1;
            if (shouldSetValue) onChange(event);
        } else if (onChange) {
            onChange(event);
        }
    };

    return (
        <StyledFormGroup controlId="exampleForm.ControlTextarea1">
            {label && (
                <StyledLabelFloating style={labelStyle}>
                    {label}
                </StyledLabelFloating>
            )}
            <StyledFormControl
                as="textarea"
                rows={5}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
                style={Object.assign(controlStyle, style)}
                disabled={disabled}
            />
            {viewLengthInfo && maxLength && (
                <StyledLengthInfo>
                    {value?.length}/{maxLength}
                </StyledLengthInfo>
            )}
        </StyledFormGroup>
    );
}

export default InputLabelTextArea;
